import React, { useState } from "react";
import { MenuIcon, XIcon } from "lucide-react";
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <div className="font-semibold text-xl text-indigo-600">
          jackcarlsoncopy
        </div>
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#services" className="text-gray-700 hover:text-indigo-600 transition-colors">
            Services
          </a>
          <a href="#packages" className="text-gray-700 hover:text-indigo-600 transition-colors">
            Packages
          </a>
          <a href="#about" className="text-gray-700 hover:text-indigo-600 transition-colors">
            About
          </a>
          <a href="#contact" className="bg-indigo-600 text-white px-5 py-2 rounded-md hover:bg-indigo-700 transition-colors">
            Get in Touch
          </a>
        </nav>
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <XIcon size={24} /> : <MenuIcon size={24} />}
        </button>
      </div>
      {isMenuOpen && <div className="md:hidden absolute top-16 left-0 right-0 bg-white shadow-md z-20 border-b border-gray-100">
          <div className="flex flex-col p-4 space-y-3">
            <a href="#services" className="text-gray-700 hover:text-indigo-600 py-2 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Services
            </a>
            <a href="#packages" className="text-gray-700 hover:text-indigo-600 py-2 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Packages
            </a>
            <a href="#about" className="text-gray-700 hover:text-indigo-600 py-2 transition-colors" onClick={() => setIsMenuOpen(false)}>
              About
            </a>
            <a href="#contact" className="bg-indigo-600 text-white px-5 py-2 rounded-md text-center hover:bg-indigo-700 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Get in Touch
            </a>
          </div>
        </div>}
    </header>;
};